export default "//static.tradera.net/touchweb/static/output/images/phone-3x.abb0511f.png";